var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.stringFormatterFindPattern"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Text to search for",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.find.pattern,
            callback: function ($$v) {
              _vm.$set(_vm.clone.find, "pattern", $$v)
            },
            expression: "clone.find.pattern",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.stringFormatterFindEnterTheTextPatternToFindInTheInput"
              )
            )
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.stringFormatterFindSkipCount"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Number of instances to skip",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.find.skip,
            callback: function ($$v) {
              _vm.$set(_vm.clone.find, "skip", $$v)
            },
            expression: "clone.find.skip",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.stringFormatterFindNumberOfOccurrencesOfThePatternToSkipBeforeReturning"
              )
            )
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }